import type { HttpTypes } from "@medusajs/types";
import { queryKeysFactory } from "../queryKeyFactory";

const ROOT_QUERY_KEY = "orders" as const;
export const orderQueryKeys = {
  ...queryKeysFactory<
    //
    typeof ROOT_QUERY_KEY,
    HttpTypes.StoreOrderFilters,
    HttpTypes.SelectParams
  >(ROOT_QUERY_KEY),
  /** Distinct product ids ordered in a trailing window (the search quick action). */
  previousProductIds: (days: number) =>
    [ROOT_QUERY_KEY, "previous-product-ids", days] as const
};
